import { render, staticRenderFns } from "./m-block-orm-receipt-view.vue?vue&type=template&id=1a639cbe&scoped=true&lang=pug&"
import script from "./m-block-orm-receipt-view.vue?vue&type=script&lang=js&"
export * from "./m-block-orm-receipt-view.vue?vue&type=script&lang=js&"
import style0 from "./m-block-orm-receipt-view.vue?vue&type=style&index=0&id=1a639cbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a639cbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VOverlay,VRow})
